import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, PickaxeIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-forest-800" data-id="element-107" data-mp="s9zxxe4wz0l5">
      <div className="h-1.5 w-full bg-gold-500" aria-hidden="true" data-id="element-108" data-mp="nczsn5fw21v3" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-109" data-mp="3d1ikzavvpeny">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold-400/50 bg-forest-900/60 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-gold-400" data-id="element-110" data-mp="3cz5ug9c21vza">
          <PickaxeIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="399jmzcfv4d5l" /> {productShortName}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.08] text-cream sm:text-5xl lg:text-6xl" data-id="element-112" data-mp="3e84nze2xv0v3">
          Master your year of mining education
          <br data-id="element-113" data-mp="2vievwyqk8t6v" />
          <span className="text-gold-400" data-id="element-114" data-mp="2vjzqgocvkc4q">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-115" data-mp="2hix1a2ql2lpl">
          <img src={productImage} alt="Mining & Mineral Resources Teacher Ready: nine volumes and five bonus resources covering fundamentals, geology and ore deposits, exploration, surface and underground mining, mineral processing, mine safety, environmental management and teaching" className="mx-auto w-full drop-shadow-2xl" data-id="element-116" data-mp="s44hnmgsjjhd" />
        </motion.div>

        <div className="mt-9" data-id="element-117" data-mp="1b049mx9rqn0y">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-118" data-mp="1622hlmud7ddc">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-cream" data-id="element-119" data-mp="11152xk8kd1gl">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-cream/15 bg-forest-900/50 px-3 py-2" data-id="element-120" data-mp="3lsoyezdi9t7k">
              <Icon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-121" data-mp="3htpzbveggqo1" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-forest-100/80" data-id="element-122" data-mp="21a4ovi31ztzn">
          Created by mining education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}